var map = {
	"./10_of_clubs.png": 3448,
	"./10_of_diamonds.png": 9840,
	"./10_of_hearts.png": 2336,
	"./10_of_spades.png": 4741,
	"./2_of_clubs.png": 9011,
	"./2_of_diamonds.png": 4561,
	"./2_of_hearts.png": 9209,
	"./2_of_spades.png": 176,
	"./3_of_clubs.png": 7568,
	"./3_of_diamonds.png": 9576,
	"./3_of_hearts.png": 8872,
	"./3_of_spades.png": 6349,
	"./4_of_clubs.png": 761,
	"./4_of_diamonds.png": 9843,
	"./4_of_hearts.png": 2119,
	"./4_of_spades.png": 9774,
	"./5_of_clubs.png": 8334,
	"./5_of_diamonds.png": 1034,
	"./5_of_hearts.png": 3614,
	"./5_of_spades.png": 3403,
	"./6_of_clubs.png": 6719,
	"./6_of_diamonds.png": 8877,
	"./6_of_hearts.png": 8653,
	"./6_of_spades.png": 6148,
	"./7_of_clubs.png": 5468,
	"./7_of_diamonds.png": 9460,
	"./7_of_hearts.png": 6508,
	"./7_of_spades.png": 6241,
	"./8_of_clubs.png": 8629,
	"./8_of_diamonds.png": 2783,
	"./8_of_hearts.png": 6395,
	"./8_of_spades.png": 4850,
	"./9_of_clubs.png": 3962,
	"./9_of_diamonds.png": 8614,
	"./9_of_hearts.png": 8306,
	"./9_of_spades.png": 1807,
	"./ace_of_clubs.png": 1678,
	"./ace_of_diamonds.png": 2682,
	"./ace_of_hearts.png": 4814,
	"./ace_of_spades.png": 1803,
	"./ace_of_spades2.png": 2081,
	"./black_joker.png": 4554,
	"./default_card.jpg": 1703,
	"./jack_of_clubs.png": 7226,
	"./jack_of_clubs2.png": 6722,
	"./jack_of_diamonds.png": 5126,
	"./jack_of_diamonds2.png": 1030,
	"./jack_of_hearts.png": 8626,
	"./jack_of_hearts2.png": 4010,
	"./jack_of_spades.png": 4415,
	"./jack_of_spades2.png": 1677,
	"./king_of_clubs.png": 5326,
	"./king_of_clubs2.png": 8398,
	"./king_of_diamonds.png": 9530,
	"./king_of_diamonds2.png": 5218,
	"./king_of_hearts.png": 9198,
	"./king_of_hearts2.png": 766,
	"./king_of_spades.png": 6187,
	"./king_of_spades2.png": 1713,
	"./queen_of_clubs.png": 4303,
	"./queen_of_clubs2.png": 4141,
	"./queen_of_diamonds.png": 7965,
	"./queen_of_diamonds2.png": 2795,
	"./queen_of_hearts.png": 6637,
	"./queen_of_hearts2.png": 395,
	"./queen_of_spades.png": 308,
	"./queen_of_spades2.png": 3500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8491;